import { OperatorsState } from "./operators.types";
import { Module, Box } from "types/orders.types";

export const getSelectedModule = (
  state: OperatorsState
): Module | undefined => {
  return state.modules?.find(module => {
    return module.id === state.selectedModuleId;
  });
};

export const getSelectedBox = (state: OperatorsState): Box | undefined => {
  const boxes = state.boxes;
  return boxes?.find(box => {
    return box.id === state.selectedBoxId;
  });
};

// find and return a module
export const getModule = (
  state: OperatorsState,
  moduleId: string
): { module: Module; moduleIndex: number; modules: Module[] } => {
  if (!state.modules) {
    throw new Error(
      `Modules should be initialized before attempting to save a box`
    );
  }
  const index = state.modules?.findIndex(module => module.id === moduleId);
  if (index === -1) {
    throw new Error(`Module id ${moduleId} does not exist on Modules`);
  }
  const modules = [...state.modules];
  const newModule = { ...modules[index] };
  return { module: newModule, moduleIndex: index, modules };
};

export const insertInModule = (
  state: OperatorsState,
  moduleId: string,
  payload: Partial<Module>
): { modules: Module[]; module: Module; moduleIndex: number } => {
  const { module, moduleIndex, modules } = getModule(state, moduleId);
  const newModule = { ...module, ...payload };
  const newModules = [...modules!];
  newModules[moduleIndex] = newModule;
  return { modules: newModules, module: newModule, moduleIndex };
};
